const LanguageTag = {
    '6498b1e91d6341510544c3b0': 'tr',
    '6498b1e91d6341510544c3b1': 'en',
    '6498b1e91d6341510544c3b2': 'es',
};

export default LanguageTag;